import { c as _c } from "react/compiler-runtime";
import { useFormatter, useTranslations } from 'next-intl';
import { TradingActivityChart } from '@/components/chart/trading-activity-chart';
import { InfoModal } from '@/components/ui/info-modal';
import { durationUnit } from './duration-unit';
import type { IntegrityActivity, IntegrityOutcome } from './resolution-integrity-types';
export function TradingActivityModal(t0) {
  const $ = _c(26);
  const {
    open,
    onOpenChange,
    activity,
    outcomes
  } = t0;
  const t = useTranslations("market.resolutionIntegrity");
  const intl = useFormatter();
  let t1;
  if ($[0] !== t) {
    t1 = t("activityTitle");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== activity.binSeconds || $[3] !== intl || $[4] !== t) {
    t2 = t("activityDescription", {
      interval: intl.number(...durationUnit(activity.binSeconds))
    });
    $[2] = activity.binSeconds;
    $[3] = intl;
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <span className="sr-only">{t2}</span>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("activityDone");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== onOpenChange) {
    t5 = () => onOpenChange(false);
    $[10] = onOpenChange;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <InfoModal.Footer cta={t4} onClose={t5} />;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== activity || $[16] !== open || $[17] !== outcomes) {
    t7 = open ? <TradingActivityChart activity={activity} outcomes={outcomes} /> : null;
    $[15] = activity;
    $[16] = open;
    $[17] = outcomes;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== onOpenChange || $[20] !== open || $[21] !== t1 || $[22] !== t3 || $[23] !== t6 || $[24] !== t7) {
    t8 = <InfoModal open={open} onOpenChange={onOpenChange} size="lg" title={t1} description={t3} footer={t6}>{t7}</InfoModal>;
    $[19] = onOpenChange;
    $[20] = open;
    $[21] = t1;
    $[22] = t3;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  return t8;
}